$(document).ready(function() {
  const loadMore = (
    loadMoreButton,
    loadMoreContainer,
    loadMoreElement,
    postsToShow,
    more
  ) => {
    $(loadMoreContainer)
      .find(loadMoreElement)
      .hide()
      .slice(0, postsToShow)
      .fadeIn()
      .addClass("lm-visible");
    if (!$(loadMoreContainer).find(loadMoreElement).not(".lm-visible").length) {
      $(loadMoreButton).addClass('disabled');
      $(loadMoreContainer).addClass('all-posts');
    }
    $(loadMoreButton).on("click", function () {
      $(loadMoreContainer)
        .find(loadMoreElement)
        .not(".lm-visible")
        .slice(0, more)
        .fadeIn()
        .addClass("lm-visible");
      if (!$(loadMoreContainer).find(loadMoreElement).not(".lm-visible").length) {
        $(loadMoreButton).addClass('disabled');
        $(loadMoreContainer).addClass('all-posts');
      } else {
        $(loadMoreButton).show();
      }
    });
  };

  loadMore('#load-more-faq', '.accordion-container', '.accordion-content', 5, 3);

  if($('.featured-collection-wrapper .swiper-container').length){
    // Loop through each featured collection wrapper separately
    $('.featured-collection-wrapper').each(function() {
      var $wrapper = $(this);
      var $container = $wrapper.find('.swiper-container');
      
      // Only initialize if this wrapper has a swiper container
      if($container.length) {
        var mySwiper = new Swiper($container[0], { // Use the specific container element
          speed: 900,
          slidesPerView: 1.2,
          watchOverflow: true,
          spaceBetween: 18,
          loop: true,
          navigation: {
            // Scope navigation to THIS wrapper only
            prevEl: $wrapper.find('.swiper-button--prev')[0],
            nextEl: $wrapper.find('.swiper-button--next')[0],
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            830: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 25,
            }
          }
        });
      }
    });
  }  

  $('.footer-email-submit').on('click', function(e){
      e.preventDefault(); // Prevent the default form submission
  
      var email = $('#Email').val();
      var consent = $('#mailing-list-consent').is(':checked');
      var formIsValid = true;
  
      // Validate email
      if (!email || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
          $('#Email').addClass('error'); // Add class 'error' if email is not valid
          formIsValid = false;
      } else {
          $('#Email').removeClass('error');
      }
  
      // Check if consent is given
      if (!consent) {
          $('#mailing-list-consent').addClass('error');
          formIsValid = false;
      } else {
          $('#mailing-list-consent').removeClass('error');
      }
  
      // If form is valid, submit via AJAX
      if (formIsValid) {
          $.ajax({
              url: '/contact#newsletter-footer_form', // Change to your actual submission URL
              type: 'POST',
              data: $('#newsletter-footer_form').serialize(),
              success: function(response) {
                  console.log('Success:', response);
                  // Replace the form with a thank you message or hide the form and show the thank you message
                  $('#newsletter-footer_form').hide(); // Hide the form
                  $('#thankYouMessage').show(); // Show the thank you message
              },
              error: function(response) {
                  console.error('Error:', response);
              }
          });
      }
  });

  var apiKey = 'pk_7600a02abf5bfdd709ecf9ae1f0eeaba4950792391adb4bbe95ec222aa4b7535'; // Replace with your actual public API key
var reviewsUrl = 'https://api.fera.ai/v3/public/store/reviews?public_key=' + apiKey + '&limit=10'; // Request more reviews initially

$.ajax({
  url: reviewsUrl,
  type: 'GET',
  headers: {
    'Accept': 'application/json'
  },
  success: function(response) {
    var reviewsHtml = '';
    var reviewsData = response.data; // Access the 'data' key from the response

    $('.number-of-reviews').html(response.meta.total_count);

    if (reviewsData && reviewsData.length > 0) {
      // Filter to include only 4 or 5-star reviews
      var filteredReviews = reviewsData.filter(function(review) {
        return review.rating >= 4;
      });

      // Show only the first 3 reviews that meet the criteria
      var reviewsToShow = filteredReviews.slice(0, 3);

      if (reviewsToShow.length > 0) {
        reviewsToShow.forEach(function(review) {
          // Calculate width for filled stars based on the rating (21px per star)
          var filledWidth = review.rating * 21; // 5 stars -> 105px full width, 21px each

          var starsHtml = `<div class="fera-review-rating fera-stars" data-fera-component="stars" data-rating="${review.rating}" style="position: relative;">
            <span class="fera--srOnly" style="position: absolute; top: 0; opacity: 0;">${review.rating}</span>
            <span class="fera-stars-bg"><b>★</b><b>★</b><b>★</b><b>★</b><b>★</b></span>
            <span class="fera-stars-rating" style="position: absolute; top: 0px; left: 0px; width: ${filledWidth}px;" data-fera-stars=""><b>★</b><b>★</b><b>★</b><b>★</b><b>★</b></span>
          </div>`;

          // Format review date to "MMM DD, YYYY"
          var reviewDate = new Date(review.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });

          var reviewHeading = review.heading || 'No title provided';
          var customerName = review.customer.display_name || 'Anonymous';

          reviewsHtml += `<div class="review-item">
            ${starsHtml}
            <h4>${reviewHeading}</h4>
            <p class="name"><strong>${customerName}</strong> on <strong>${reviewDate}</strong></p>
            <div class="copy"><p>${review.body}</p></div>
          </div>`;
        });
      } else {
        reviewsHtml = '<p>No 4 or 5-star reviews available yet.</p>';
      }
    } else {
      reviewsHtml = '<p>No reviews available yet.</p>';
    }
    $('#custom-store-reviews-container').html(reviewsHtml);
  },
  error: function() {
    $('#custom-store-reviews-container').html('<p>Error loading reviews. Please try again later.</p>');
  }
});


  $(document).on('click', '.mobile-facets__open', function(){
    $('body').removeClass('js-drawer-open js-drawer-open-left');
  });

  $('.quick-add-button-variants').on('click', function() {
    setTimeout(function() { // Delay the execution of the inside block
        var $textContainer = $('#ShopNowContainer').find('.product-description .copy');

        // Initially hide all p elements except the first
        $textContainer.find('p:not(:first)').hide();

        // Check if the toggle element already exists to avoid adding it multiple times
        if ($textContainer.find('.toggle-text-div').length === 0) {
            // Create and append the Read More/Less div
            var $toggleDiv = $('<div/>', {
                text: 'read more',
                class: 'toggle-text-div underlined-link black',
                click: function() {
                    // Toggle visibility of all but the first paragraph
                    $textContainer.find('p:not(:first)').toggle();

                    // Update the text of the toggle div based on visibility
                    $(this).text($(this).text() === 'read more' ? 'read less' : 'read more');
                }
            });

            // Append the toggle div inside the text container, below the paragraphs
            $textContainer.append($toggleDiv);
        }
    }, 2000); // Delay time in milliseconds
  });

  var contentDiv = $('.product-description .copy');
  var paragraphs = contentDiv.find('p');

  if (paragraphs.length > 1) {
      // Hide all paragraphs except the first one
      paragraphs.slice(1).hide();

      // Append the Read More link to the first paragraph
      paragraphs.first().append(' <a href="#" class="read-more">Read More</a>');

      // Append the Read Less link to the last paragraph and hide it initially
      paragraphs.last().append(' <a href="#" class="read-less" style="display: none;">Read Less</a>');

      // Add event listener for the Read More link
      contentDiv.on('click', '.read-more', function(e) {
          e.preventDefault();
          paragraphs.slice(1).slideDown();
          $(this).hide();
          contentDiv.find('.read-less').show();
      });

      // Add event listener for the Read Less link
      contentDiv.on('click', '.read-less', function(e) {
          e.preventDefault();
          paragraphs.slice(1).slideUp();
          $(this).hide();
          contentDiv.find('.read-more').show();
      });
  }
});

document.addEventListener('DOMContentLoaded', function(){
  // Function to parse price string and convert to float
  function parsePrice(priceString) {
    return parseFloat(priceString.replace('£', '').replace(',', ''));
  }

  // Function to create and insert price elements
  function createPriceElements() {
      var $priceContainer = $('.infiniteoptions-price');

      var priceHTML = `
          <div class="prices">
            <div class="product-total">
              <span>Product Total:</span>
              <div class="price" id="product-price-total"></div>
            </div>
            <div class="options-total">
              <span>Options Total:</span>
              <div class="price" id="options-price-total"></div>
            </div>
            <div class="total">
              <span>Grand Total:</span>
              <div class="price" id="grand-total-price"></div>
            </div>
          </div>
      `;

      $priceContainer.append(priceHTML);
  }

  // Function to update prices
  function updatePrices() {
      var basePrice = parsePrice($('#ProductPrice .money').text());
      var grandTotalPrice = parsePrice($('.infiniteoptions-price .price-item--regular').text());

      var optionsPrice = grandTotalPrice - basePrice;

      // Update the displayed prices
      $('#product-price-total').text('£' + basePrice.toFixed(2));
      $('#options-price-total').text('£' + optionsPrice.toFixed(2));
      $('#grand-total-price').text('£' + grandTotalPrice.toFixed(2));
  }

  setTimeout(() => {
    // Check if #infiniteoptions-container exists
    if ($('#infiniteoptions-container').children().length > 0) {
      // Create price elements on load
      createPriceElements();

      // Initial calculation
      updatePrices();

      // Bind change event to Infinite Options (if options can change the price dynamically)
      $(document).on('change', '#infiniteoptions-container select', updatePrices);
  }
  }, 2500);

  // Function to trigger update on dropdown item click
  function triggerUpdate() {
    const dropdownWrapper = document.querySelector('.variant-dropdown__wrapper');
    const dropdownButton = document.querySelector('#SingleOptionSelector-0');

    if (!dropdownWrapper || !dropdownButton) return;

    // Add 'updating' class to disable dropdown
    dropdownWrapper.classList.add('updating');

    // Programmatically trigger the click on the dropdown button
    setTimeout(() => {
      dropdownButton.click();
    }, 300);

    // Wait for 700ms, then remove the 'updating' class and close dropdown
    setTimeout(() => {
        dropdownButton.click(); // Close the dropdown
    }, 1000);

    setTimeout(() => {
      dropdownWrapper.classList.remove('updating');
    }, 1500);
  }

  // Attach event listener to each dropdown item
  $(document).on('click', '[data-dropdown-option]', triggerUpdate);
})

$(document).on('recommendations:loaded', function(){
  if($('.featured-collection-wrapper .swiper-container').length){
    var mySwiper = new Swiper('.featured-collection-wrapper .swiper-container', {
      speed: 900, // 900ms transition speed
      slidesPerView: 1.2,
      watchOverflow: true,
      spaceBetween: 18,
      loop: true,
      navigation: {
        prevEl: '.featured-collection-wrapper .swiper-button--prev',
        nextEl: '.featured-collection-wrapper .swiper-button--next',
      },
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        830: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25,
        }
      }
    });
  }
})